import { GrupoFormKeys } from 'src/modules/grupo/form'
import { Places } from '../../../Constants'

export class AnaliseSelectKeys extends GrupoFormKeys {
    get place() {
        return Places.analiseSelect
    }
}

export default AnaliseSelectKeys
